module.exports = __webpack_public_path__ + "static/media/Desktop-community-1.9b68d6fd.jpg";